/**
 * @generated SignedSource<<9fd748189afe70c40e26607d570ef263>>
 * @relayHash 957b72bb96276dcd3ecef3b1b59c5bad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67aeac5be4cd8403bd1b832069b94244b9c080ad975513427de96375b0d898b3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type BillingSourceSystem = "CCP" | "HAMS" | "%future added value";
export type PremiumTrialEotQuery$variables = Record<PropertyKey, never>;
export type PremiumTrialEotQuery$data = {
  readonly license: {
    readonly billingSourceSystem: BillingSourceSystem | null | undefined;
    readonly trialEndDate: string | null | undefined;
  } | null | undefined;
};
export type PremiumTrialEotQuery = {
  response: PremiumTrialEotQuery$data;
  variables: PremiumTrialEotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "billingSourceSystem"
      },
      {
        "kind": "ScalarField",
        "name": "trialEndDate"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PremiumTrialEotQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PremiumTrialEotQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "957b72bb96276dcd3ecef3b1b59c5bad",
    "id": "67aeac5be4cd8403bd1b832069b94244b9c080ad975513427de96375b0d898b3",
    "metadata": {},
    "name": "PremiumTrialEotQuery",
    "operationKind": "query",
    "text": "query PremiumTrialEotQuery{license{billingSourceSystem,trialEndDate}}"
  }
};
})();

(node as any).hash = "69c9bd0e5618a81401451ee2bba96a40";

export default node;
